import { render, staticRenderFns } from "./MemberGrades.vue?vue&type=template&id=a9133afa"
import script from "./MemberGrades.vue?vue&type=script&lang=js"
export * from "./MemberGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports